'use client'

import {type LinkProps as NextLinkProps} from 'next/link'
import {usePathname} from 'next/navigation'
import {mercuryUrl} from '~/data/mercury'
import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '~/design-system/foundations/Breadcrumb'
import HgTextLink from '../HgTextLink'
import {type BreadcrumbLinkProps} from './types'

export function HgBreadcrumbItem({
  breadcrumb,
  withSeparator,
}: {
  breadcrumb: BreadcrumbLinkProps
  withSeparator: boolean
}) {
  const pathname = usePathname()
  const getBreadcrumbPathname = (href: NextLinkProps['href']) => {
    if (typeof href === 'string') {
      const baseUrl = href.startsWith('/') ? mercuryUrl : undefined
      return URL.canParse(href, baseUrl) ? new URL(href, baseUrl).pathname : ''
    }
    if (href && 'pathname' in href) {
      return href.pathname
    }
    return ''
  }
  // NB: This makes the assumption that breadcrumb links are to mercury domains
  const isCurrentPage = pathname === getBreadcrumbPathname(breadcrumb.link.href)

  return (
    <>
      <BreadcrumbItem>
        {isCurrentPage ? (
          <BreadcrumbPage className="text-text-subdued arcadia-body-3">
            {breadcrumb.label}
          </BreadcrumbPage>
        ) : (
          <BreadcrumbLink
            data-analytics-event-name={breadcrumb.link.analyticsEventName}
            asChild
          >
            <HgTextLink
              className="text-text-subdued arcadia-body-3"
              href={breadcrumb.link.href}
              variant="underline"
            >
              {breadcrumb.label}
            </HgTextLink>
          </BreadcrumbLink>
        )}
      </BreadcrumbItem>
      {withSeparator && <BreadcrumbSeparator className="px-s2 text-icon-subdued" />}
    </>
  )
}
